<template>
	<VAlert
		v-if="messages && messages !== null && messages.length > 0"
		dense
		type="info"
		color="primary"
		:icon="infoIcon"
		class="ma-0"
		prominent
	>
		<p
			v-for="(item, key) in messages"
			:key="key"
			class="ma-1 white--text"
		>
			{{ item.contenu }}
		</p>
	</VAlert>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';
	import { mapActions, mapState } from 'vuex';
	import { mdiInformation } from '@mdi/js';

	@Component({
		computed: mapState('messageUtilisateurs', ['messages']),
		methods: mapActions('messageUtilisateurs', ['updateMessageUtilisateurs'])
	})
	export default class MessageBar extends Vue {
		infoIcon = mdiInformation;
		mounted(): void {
			this.updateMessageUtilisateurs();
		}
	}
</script>
